import { Channel } from 'api/ChannelsAPI';
import { MessageType } from 'api/MessageTypeAPI';

export interface ModalProps {
  onClose: () => void;
  channel?: Channel;
  messageType?: MessageType;
  isEditMode: boolean;
}

export type ManageMessageTypeProps = {
  onSubmit: (params: any) => void;
  nextAction?: () => void;
  actionLoading: boolean;
} & ModalProps;

export type DoubleOptInMessageTypeProps = {
  isUpdateToDoubleOptInMode: boolean;
  onSubmit: (params: any) => void;
  prevAction?: () => void;
  actionLoading: boolean;
} & ModalProps;

export enum ModalView {
  CREATE_OR_UPDATE_MESSAGE_TYPE = 'createOrUpdateMessageType',
  CREATE_DOUBLE_OPT_IN_MESSAGE_TYPE = 'createDoubleOptInMessageType',
}
